import { render, staticRenderFns } from "./SubCategoryLandingPage.vue?vue&type=template&id=39df2788&scoped=true"
import script from "./SubCategoryLandingPage.vue?vue&type=script&lang=js"
export * from "./SubCategoryLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39df2788",
  null
  
)

export default component.exports